import { FilterArea } from "#src/components/FilterArea";
import { FilterDrawer } from "#src/components/FilterDrawer";
import { TextInput, type StorageKeys } from "@validereinc/common-components";
import React from "react";

export const MeasurementTypeViewFilterArea = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => {
  const measurementType = "measurementType";

  return (
    <FilterArea.Root storageKey={filterConfigStorageKey}>
      <FilterArea.Container aria-label={`Filters for Measurement Types`}>
        <FilterDrawer.Root>
          <FilterArea.Content>
            {({ handleOnChange }) => (
              <div style={{ marginRight: 0, marginBottom: 0 }}>
                <TextInput
                  name="measurementType"
                  label="Search"
                  isLabelShown={false}
                  placeholder={"Search Measurements..."}
                  type="search"
                  isInline
                  onChange={(val) => handleOnChange(val, measurementType)}
                />
              </div>
            )}
          </FilterArea.Content>
        </FilterDrawer.Root>
      </FilterArea.Container>
    </FilterArea.Root>
  );
};
